import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import {
    InvoicePaymentAuthorizedModel,
    InvoicePaymentConfirmationModel,
    InvoicePaymentCustomerModel,
    InvoicePaymentInvoiceModel,
    InvoicePaymentPortalModel,
    InvoicePaymentTypeAccountModel,
} from "@store/Types/InvoicePayment";

const authorizedUrl = "/api/v1/invoicepayment/authorized";
const customerUrl = "/api/v1/invoicepayment/customer";
const processPaymentUrl = "/api/v1/invoicepayment/processpayment";
const confirmationUrl = "/api/v1/invoicepayment";
const paymentPortalUrl = "/api/v1/invoicepayment/paymentportal";

export interface GetInvoicePaymentAuthorizedParameter extends ApiParameter {}

export interface GetInvoicePaymentCustomerParameter extends ApiParameter {}

export interface ProcessInvoicePaymentParameter extends ApiParameter {
    account: InvoicePaymentTypeAccountModel;
    invoicePaymentCustomerId: string;
    invoicesToPay: InvoicePaymentInvoiceModel[];
    paymentAmount: number;
}

export interface GetInvoicePaymentConfirmationParameter extends ApiParameter {
    paymentOutcomeId: string;
}

export interface GetInvoicePaymentPortalParameter extends ApiParameter {}

export function getInvoicePaymentAuthorized(parameter: GetInvoicePaymentAuthorizedParameter) {
    return get<InvoicePaymentAuthorizedModel>(authorizedUrl, parameter);
}

export function getInvoicePaymentCustomer(parameter: GetInvoicePaymentCustomerParameter) {
    return get<InvoicePaymentCustomerModel>(customerUrl, parameter);
}

export function processInvoicePayment(parameter: ProcessInvoicePaymentParameter) {
    return post<ProcessInvoicePaymentParameter, InvoicePaymentConfirmationModel>(processPaymentUrl, parameter);
}

export function getPaymentConfirmation(parameter: GetInvoicePaymentConfirmationParameter) {
    const { paymentOutcomeId } = parameter;
    return get<InvoicePaymentConfirmationModel>(`${confirmationUrl}/${paymentOutcomeId}`);
}

export function getInvoicePaymentPortal(parameter: GetInvoicePaymentPortalParameter = {}) {
    return get<InvoicePaymentPortalModel>(paymentPortalUrl, parameter);
}
